import { render } from "./countByPenitenciariesCenters.vue?vue&type=template&id=b3bf3ef4"
import script from "./countByPenitenciariesCenters.vue?vue&type=script&lang=js"
export * from "./countByPenitenciariesCenters.vue?vue&type=script&lang=js"

import "./countByPenitenciariesCenters.vue?vue&type=style&index=0&id=b3bf3ef4&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__